import { trackAnalyticsEvent } from '../track'

interface TrackSortChangedParams {
  page: string
  sortBy: string
  sortDirection: 'asc' | 'desc'
  trigger: 'option' | 'direction' | 'clear'
  isDefault: boolean
}

export function trackSortChanged({
  page,
  sortBy,
  sortDirection,
  trigger,
  isDefault
}: TrackSortChangedParams) {
  trackAnalyticsEvent('sort_changed', {
    page,
    sort_by: sortBy,
    sort_direction: sortDirection,
    trigger,
    is_default: isDefault
  })
}
